import { FileText } from 'lucide-react'

function Blog() {
  const blogPosts = [
    {
      title: 'Understanding Nonwoven Fabric Quality',
      excerpt: 'Learn about the different grades of nonwoven materials and how to choose the right one for your packaging needs.',
      date: 'March 15, 2024',
      readTime: '5 min read',
    },
    {
      title: 'Sustainable Packaging Trends in 2024',
      excerpt: 'Explore the latest trends in eco-friendly packaging solutions and how businesses are making the switch.',
      date: 'March 10, 2024',
      readTime: '7 min read',
    },
    {
      title: 'Custom Bag Design Best Practices',
      excerpt: 'Tips and guidelines for designing custom bags that effectively represent your brand identity.',
      date: 'March 5, 2024',
      readTime: '6 min read',
    },
  ]

  return (
    <section id="blog" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-semibold text-apple-gray-900 tracking-tight mb-4">
            Latest Insights
          </h2>
          <p className="text-lg text-apple-gray-600 max-w-2xl mx-auto">
            Stay updated with industry trends, tips, and best practices for sustainable packaging
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {blogPosts.map((post, index) => (
            <article
              key={index}
              className="group bg-apple-gray-50 rounded-2xl p-8 hover:bg-apple-gray-100 transition-colors border border-apple-gray-200 cursor-pointer"
            >
              <div className="flex items-center gap-2 text-apple-gray-500 text-xs mb-4">
                <FileText size={14} />
                <span>{post.date}</span>
                <span>•</span>
                <span>{post.readTime}</span>
              </div>
              <h3 className="text-xl font-semibold text-apple-gray-900 mb-3 group-hover:text-apple-gray-700 transition-colors">
                {post.title}
              </h3>
              <p className="text-apple-gray-600 text-sm leading-relaxed mb-4">
                {post.excerpt}
              </p>
              <a href="#" className="inline-flex items-center gap-2 text-apple-gray-900 font-medium text-sm hover:gap-3 transition-all">
                Read More →
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Blog
